import { useAuth } from '@proptr/api-client/react';
import { AppShell } from '../components/layout/AppShell.js';
import { Card } from '../components/ui/card.js';

export function DashboardPage() {
  const { user } = useAuth();
  return (
    <AppShell>
      <div className="space-y-8">
        <div>
          <div className="eyebrow">Admin console</div>
          <h1 className="font-display text-[40px] font-medium leading-none tracking-[-0.02em]">
            Welcome{user?.name ? `, ${user.name.split(' ')[0]}` : ''}.
          </h1>
          <p className="mt-3 font-mono text-[11px] text-muted-foreground">
            Signed in as <span className="text-foreground">{user?.email}</span> ·{' '}
            <span className="text-foreground">{user?.role}</span>
          </p>
        </div>

        <Card className="p-6">
          <div className="space-y-2">
            <div className="eyebrow">Coming next</div>
            <p className="font-sans text-[14px] leading-relaxed">
              "Login as manager" workflow — pick an enterprise's manager and impersonate
              them to access the manager portal with admin-level dropdown actions
              unlocked.
            </p>
          </div>
        </Card>
      </div>
    </AppShell>
  );
}
